const actions = {
  SET_STATE: 'user/SET_STATE',
  LOGIN: 'user/LOGIN',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  CHECK_TOKEN: 'user/CHECKTOKEN',
  LOGOUT: 'user/LOGOUT',
  UPDATE_PROFILE: 'user/Update_Profile',
  SEND_OTP: 'otp/Send_OTP',
}

export default actions
